import { Logger } from "@suse-o11y/logger";
import { catchError } from "@suse-o11y/rxjs";
import type { AnyAction } from "redux";
import { type Epic, combineEpics } from "redux-observable";

import type { EpicDependencies } from "../../app/state/ReduxStore";
import type { RootState } from "../../app/state/RootState";

export function combineEpicsAndCatchErrors(
	...epics: Array<Epic<AnyAction, AnyAction, RootState>>
): Epic<AnyAction, AnyAction, RootState, EpicDependencies> {
	const logger = Logger.namespace("CombineEpicsAndCatchErrors");

	function wrap(epic: Epic<AnyAction, AnyAction, RootState>): Epic<AnyAction, AnyAction, RootState> {
		return (actions, states, dependencies: any) =>
			epic(actions, states, dependencies).pipe(
				catchError((error: unknown, source) => {
					logger.error(`Epic '${epic.name}' has thrown an error.`, error);
					return source;
				}),
			);
	}

	return (actions, states, dependencies) => combineEpics(...epics.map(wrap))(actions, states, dependencies);
}
